export default __webpack_public_path__ + "static/img/mensch-bg.2153169.jpg";